import { createAction, props } from "@ngrx/store";
import { PaginationRequest } from "src/app/models/common/paginationRequest";
import {
  SiteDeviceTankLevelGaugesDTO,
  TankLevelGaugesDTO,
} from "src/app/models/tank-gauges/tank-gaugesDTO";

export const getTankGauge = createAction(
  "[TankGauge] Get a Tank Gauge by code Action",
  props<{ code: string }>()
);
export const loadTankGauge = createAction(
  "[TankGauge] Load a Tank Gauge by code Action",
  props<{ tankGauge: TankLevelGaugesDTO }>()
);

export const getTankGaugeTypes = createAction(
  "[TankGauge] Get a Tank Gauge Type by code Action",
  props<{ pageReq: PaginationRequest }>()
);
export const loadTankGaugeTypes = createAction(
  "[TankGauge] Load a Tank Gauge Types by code Action",
  props<{ response: any }>()
);

export const getTankGauges = createAction(
  "[TankGauge] Get All Tank Gauges Action",
  props<{ code: string, pageReq?: PaginationRequest }>()
);
export const loadTankGauges = createAction(
  "[TankGauge] Load All Tank Gauges Action",
  props<{ response: any[] }>()
);
export const getWarehouses = createAction(
  "[TankGauge] Get All Warehouses Action",
  props<{ options: any }>()
);
export const loadWarehouses = createAction(
  "[TankGauge] Load All Warehouses Action",
  props<{ response: any[] }>()
);

// Table Configuration Settings
export const getTankGaugeTableConfig = createAction(
  "[TankGauge] Get Tank Gauge Table Configuration Action",
  props<{ options: any }>()
);
export const loadTankGaugeTableConfig = createAction(
  "[TankGauge] Load Tank Gauge Table Configuration Action",
  props<{ response: any[] }>()
);
export const saveTankGaugeTableConfig = createAction(
  "[TankGauge] Save Tank Gauge Table Configuration Action",
  props<{ config: any }>()
);
export const updateTankGauge = createAction(
  "[TankGauge] Update Tank Gauge Action",
  props<{ tankGauge: SiteDeviceTankLevelGaugesDTO }>()
);
export const createTankGauge = createAction(
  "[TankGauge] Create Tank Gauge Action",
  props<{ tankGauge: SiteDeviceTankLevelGaugesDTO }>()
);
export const resetTankGauge = createAction(
  "[TankGauge] Reset Tank Gauge Action"
);
export const resetTankGaugeState = createAction(
  "[TankGauge] Reset Tank Gauges State Action"
);
export const resetCreation = createAction(
  "[TankGauge] Reset Tank Gauges Creation Action"
);
export const getLoadingState = createAction(
  "[TankGauge] Get Tank Gauge Loading State Action"
);
export const setLoadingEndState = createAction(
  "[TankGauge] Set Tank Gauge Loading End State Action"
);
